import { Link } from 'react-router';

interface PageNotFoundProps {
  statusCode?: string;
  title?: string;
  subtitle?: string;
}
export default function PageNotFound(props: PageNotFoundProps) {
  const {
    statusCode = '404',
    title = 'Oops! Page not found',
    subtitle = 'The page you are looking for was not found. Please check the URL in the address bar and try again.',
  } = props;

  return (
    <div className='h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8'>
      <div className='max-w-max mx-auto'>
        <main className='sm:flex'>
          <p className='text-4xl font-extrabold text-neutralColor-dark sm:text-5xl'>
            {statusCode.charAt(0)}
            <span style={{ color: '#0FCA98' }}>{statusCode.charAt(1)}</span>
            {statusCode.charAt(2)}
          </p>
          <div className='sm:ml-6'>
            <div className='sm:border-l sm:border-gray-200 sm:pl-6'>
              <h1 className='text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl'>{title}</h1>
              <p className='mt-1 text-base text-gray-500'>{subtitle}</p>
            </div>
            <div className='mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6'>
              <Link
                to='/terminal/dashboard'
                className='inline-flex items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-md shadow-sm text-white bg-primaryColor-normal hover:bg-priamryColor-medium focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primaryColor-normal'
              >
                Go back home
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
